import { defineComponent } from 'vue';
import image from './assets/munet.avif';
import ServerStatus from '@/components/ServerStatus';

export default defineComponent({
  render() {
    return (
      <div class="max-w-100 mx-auto p-4 pt-12 flex flex-col items-center gap-2 h-100dvh">
        <img src={image} class="w-full mb-10" />
        <div class="text-5 font-600">
          <a href="https://portal.mumur.net">登录</a>
          {' | '}
          <a href="https://status.mumur.net" target="_blank">服务状态</a>
        </div>
        <ServerStatus class="mt-2" />
        <div class="grow" />
        <div class="c-#606266">© 2025 MuNET Team</div>
      </div>
    );
  },
});
